module.exports = __webpack_public_path__ + "img/CIC.42b3bd86.png";